import navSlice from './navSlice';

export const { updateActivePrimary, updateActiveSecondary } = navSlice.actions;
export default navSlice.reducer;
